export default "__VITE_ASSET__C2Jrcu8q__"